import { Alert, Snackbar } from '@mui/material';

const AUTO_HIDE_DURATION_MS = 4000;

type ToastProps = {
  open: boolean;
  message: string;
  onClose: () => void;
};

/**
 * No toast/Snackbar pattern exists anywhere in the repo (confirmed at
 * CHECKPOINT 3 — grepped for Snackbar/useToast/notistack, zero hits;
 * `Alert` elsewhere is only ever used as a static inline error banner).
 * Scoped locally to this feature rather than added as a new shared
 * ui-components primitive, per the approved plan.
 */
export const Toast = ({ open, message, onClose }: ToastProps) => (
  <Snackbar
    open={open}
    autoHideDuration={AUTO_HIDE_DURATION_MS}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    data-testid="case-cart-toast"
  >
    <Alert onClose={onClose} severity="success" variant="filled">
      {message}
    </Alert>
  </Snackbar>
);
